module.exports = __webpack_public_path__ + "img/Panorama_Heron_2.a623d46f.webp";